import { all, takeEvery } from 'redux-saga/effects';
import {
    RESET_FILTERS,
    UPDATE_BENCHMARKING,
    UPDATE_DATA_TYPE,
    UPDATE_FILTER_ITEM,
    UPDATE_NAV_ITEM,
    UPDATE_SORT
} from '../actions';
import { updateNavItem } from './update-nav-item';
import { updateFilterItem } from './update-filter-item';
import { updateSort } from './update-sort';
import { resetFilters } from './reset-filters';
import { updateBenchmarking } from './update-benchmarking';
import { updateDataType } from './update-data-type';

/**
 *
 */
export function* statsLeadersRootSaga() {
    yield all([
        takeEvery(UPDATE_NAV_ITEM.REQUEST, updateNavItem),
        takeEvery(UPDATE_FILTER_ITEM.REQUEST, updateFilterItem),
        takeEvery(RESET_FILTERS.REQUEST, resetFilters),
        takeEvery(UPDATE_SORT.REQUEST, updateSort),
        takeEvery(UPDATE_BENCHMARKING.REQUEST, updateBenchmarking),
        takeEvery(UPDATE_DATA_TYPE.REQUEST, updateDataType)
    ]);
}
